import { render, staticRenderFns } from "./FolderSyncOutline.vue?vue&type=template&id=9fece8e4"
import script from "./FolderSyncOutline.vue?vue&type=script&lang=js"
export * from "./FolderSyncOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports